import { render, staticRenderFns } from "./LetterboxCreate.vue?vue&type=template&id=33e051e4&scoped=true&"
import script from "./LetterboxCreate.vue?vue&type=script&lang=ts&"
export * from "./LetterboxCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e051e4",
  null
  
)

export default component.exports